/**
 * @name: Demo Name
 * @description: Demo Description
 */
import React, { Component } from 'react'
import '../style'
import './demo.less'
import '../../../theme/index.less'

export default class Demo extends Component {
  render () {
    return (
      <div>123</div>
    )
  }
}
